/**
 * Check if asset is a fund.
 * @param {Asset} asset Asset to be checked. Need to has 'tipo' or 'Tipo' fields.
 * @returns {Boolean} is a fund?
 */
export const isFund = ({ tipo, Tipo }) => {
  return [
    'fundos de investimentos',
    'fundos de previdência',
    'fundos',
    'fundo',
    'fundos de investimento',
    'fundo de investimento',
  ].includes((tipo || Tipo || '').toLowerCase())
}

export const isCripto = ({tipo, Tipo}) => {
  return ["criptoativos"].includes((tipo || Tipo || "").toLowerCase())
}

/**
 * Check if asset is a stock.
 * @param {Asset} asset Asset to be checked. Need to has 'tipo' or 'Tipo' fields.
 * @returns {Boolean} is a stock?
 */
export const isStock = ({ tipo, Tipo }) => {
  return [
    'ação',
    'ações',
    'fii',
    'fundos imobiliários',
    'fundo imobiliário',
  ].includes((tipo || Tipo || '').toLowerCase())
}

/**
 * Check if asset is a RF.
 * @param {Asset} asset Asset to be checked. Need to has 'tipo' or 'Tipo' fields.
 * @returns {Boolean} is a RF?
 */
export const isRF = ({ tipo, Tipo }) => {
  return ['renda fixa', 'tesouro direto'].includes(
    (tipo || Tipo || '').toLowerCase()
  )
}

export const ASSET_DECIMAL_PRECISION = {
  personalizado: { pu: 8, quantidade: 8 },
  'personalizado offshore': { pu: 8, quantidade: 8 },
  'fundos de investimentos': { pu: 8, quantidade: 8 },
  'fundos de investimento': { pu: 8, quantidade: 8 },
  'fundo de investimento': { pu: 8, quantidade: 8 },
  'fundos de previdência': { pu: 8, quantidade: 8 },
  fundos: { pu: 8, quantidade: 8 },
  fundo: { pu: 8, quantidade: 8 },
  bonds: { pu: 2, quantidade: 15 },
  offshore: { pu: 2, quantidade: 15 },
  'fundos offshore': { pu: 2, quantidade: 15 },
  criptoativos: { pu: 2, quantidade: 15 },
}

export const DEFAULT_DECIMAL_PRECISION = { pu: 2, quantidade: 2 }

const assetDecimalPrecision = ({ tipo, Tipo }) => {
  return (
    ASSET_DECIMAL_PRECISION[(tipo || Tipo || '').toLowerCase()] ||
    DEFAULT_DECIMAL_PRECISION
  )
}

/**
 * Check length of decimal at PU.
 * @param {Asset} asset Asset to be checked. Need to has 'tipo' or 'Tipo' fields.
 * @returns {Number} Length of decimal at PU.
 */
export const decimalLengthPU = ({ tipo, Tipo }) => {
  if (isFund({ tipo, Tipo })) return 8
  return assetDecimalPrecision({ tipo, Tipo }).pu
}

/**
 * @param {Asset} asset Asset to be checked. Need to has 'tipo' or 'Tipo' fields.
 * @returns {Number} Length of decimal at quantity.
 */
export const decimalLengthQuantity = ({ tipo, Tipo }) => {
  return assetDecimalPrecision({ tipo, Tipo }).quantidade
}

/**
 * @param {Number} decimals Number of decimal places.
 * @returns {String} Placeholder like '0,00000000' for 8 (or '0' for none).
 */
export const decimalPlaceholder = (decimals) => {
  return decimals > 0 ? `0,${'0'.repeat(decimals)}` : '0'
}

/**
 * Check if the asset has buy price.
 * @param {Asset} asset Asset to be checked. Need to has 'tipo' or 'Tipo' fields.
 * @returns {Number} Has buy price.
 */
export const hasBuyPrice = ({ tipo, Tipo }) => {
  return ['renda fixa', 'operações estruturadas'].includes(
    (tipo || Tipo || '').toLowerCase()
  )
}
